import type { MunduEvent } from 'src/domain/event';
import type { OrganizationGroup } from 'src/domain/organization';

type FilterableCalendarEvent = Pick<MunduEvent, 'createdById' | 'target'>;

export const isCalendarEventCreatedByUser = (
    event: FilterableCalendarEvent,
    userId?: string,
) => Boolean(userId && event.createdById === userId);

export const isCalendarEventInGroupScope = (
    event: FilterableCalendarEvent,
    groupIds: string[],
    hasOrganizationScope: boolean,
    groups: OrganizationGroup[] = [],
) => {
    if (hasOrganizationScope || event.target.sendToAll) {
        return true;
    }

    if (!groupIds.length) {
        return false;
    }

    const groupIdSet = new Set(groupIds);
    const groupById = new Map(groups.map(group => [group.id, group]));

    groupIds.forEach(groupId => {
        let parentId = groupById.get(groupId)?.parentId;
        const visited = new Set<string>();

        while (parentId && !visited.has(parentId)) {
            visited.add(parentId);
            groupIdSet.add(parentId);
            parentId = groupById.get(parentId)?.parentId;
        }
    });

    return (event.target.groupIds ?? []).some(groupId =>
        groupIdSet.has(groupId),
    );
};
